import { DATA_STYLE,HEADER_STYLE } from "../excelReportStyles";
import {
  addBordersToSheet,
  formatPlantTrainName,
  parseJSON,
} from "../excelReportUtils";

import { formatDate } from "../../../../utils/Utils";

export const createReplacementAlertSheet = (sheet, plants, t) => {
  const allReplacementData = [];

  plants.forEach((plant) => {
    const collectReplacementRows = (raPredictions, trainNum, plantId, plantName) => {
      const replacementResults = raPredictions.replacement_results || [];
      if (replacementResults.length > 0) {
        replacementResults.forEach((alert) => {
          allReplacementData.push({
            plant_id: plantId,
            plant_name: plantName || "Plant",
            train_num: trainNum,
            forecasted_date: alert.forecasted_date || "-",
            trigger: alert.trigger || "-",
            explanation: alert.explanation || "-",
          });
        });
        return;
      }

      allReplacementData.push({
        plant_id: plantId,
        plant_name: plantName || "Plant",
        train_num: trainNum,
        forecasted_date: "-",
        trigger: "-",
        explanation: "-",
      });
    };

    if (plant?.trains && Array.isArray(plant.trains)) {
      plant.trains.forEach((train) => {
        collectReplacementRows(
          parseJSON(train.ra_predictions),
          train.train_num,
          plant.plant_id,
          plant.plant_name,
        );
      });
    } else if (plant?.ra_predictions) {
      collectReplacementRows(
        parseJSON(plant.ra_predictions),
        plant.train_num,
        plant.plant_id,
        plant.plant_name,
      );
    }
  });

  const headers = [
    t("benchMark.headers.plantName"),
    t("benchMark.headers.forecastedDate"),
    t("benchMark.headers.trigger"),
    t("benchMark.headers.potentialExplanation"),
  ];

  const headerRow = sheet.getRow(1);
  headers.forEach((header, idx) => {
    const cell = headerRow.getCell(idx + 1);
    cell.value = header;
    Object.assign(cell, HEADER_STYLE);
  });
  headerRow.commit();

  allReplacementData.forEach((data, idx) => {
    const row = sheet.getRow(2 + idx);

    const values = [
      formatPlantTrainName(data.plant_name, data.plant_id, data.train_num),
      data.forecasted_date !== "-" ? formatDate(data.forecasted_date) : "-",
      data.trigger || "-",
      data.explanation || "-",
    ];

    values.forEach((value, valueIdx) => {
      const cell = row.getCell(valueIdx + 1);
      cell.value = value;
      Object.assign(cell, DATA_STYLE);
    });

    row.commit();
  });

  sheet.columns = [{ width: 35 }, { width: 18 }, { width: 30 }, { width: 30 }];
  addBordersToSheet(sheet);
};
